var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoJeftinije(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 17,
    viewBox: "0 0 62 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24238_10581)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24238_10581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V17H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24238_10581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46833 13.7182V4.27371H3.22389V13.7182C3.22389 15.6543 2.46833 17.1418 -0.0650024 17.0001V15.3473C1.17944 15.3709 1.46833 14.9932 1.46833 13.7182ZM2.35722 0.519547C2.95722 0.519547 3.44611 1.039 3.44611 1.6765C3.44611 2.314 2.95722 2.83344 2.35722 2.83344C1.75722 2.83344 1.24611 2.314 1.24611 1.6765C1.24611 1.039 1.75722 0.519547 2.35722 0.519547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.286 4.08371C12.0193 4.08371 13.9749 6.44482 13.6638 9.4198H6.61933C6.8638 10.8601 7.95266 11.8754 9.41933 11.8754C10.5305 11.8754 11.4415 11.2615 11.9305 10.2698L13.3971 10.9545C12.6638 12.442 11.2193 13.481 9.37486 13.481C6.81933 13.481 4.86377 11.4504 4.86377 8.7823C4.86377 6.13788 6.77486 4.08371 9.286 4.08371ZM11.9082 7.97954C11.6193 6.68093 10.6415 5.71288 9.286 5.71288C7.99713 5.71288 6.97486 6.65732 6.6638 7.97954H11.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3097 5.92542H14.4875V4.27264H16.3097V3.5407C16.3097 1.29764 17.332 0.235138 19.532 0.235138H20.4653V1.88791H19.532C18.4875 1.88791 18.0653 2.36014 18.0653 3.46986V4.29625H26.532V5.94903H23.6209V10.1282C23.6209 11.2379 24.0431 11.7102 25.0653 11.7102H25.4209V13.3629H25.0653C22.8875 13.3629 21.8653 12.2768 21.8653 10.0573V5.97264H18.0653V13.3629H16.3097V5.92542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7745 0.519547C29.3745 0.519547 29.8634 1.039 29.8634 1.6765C29.8634 2.314 29.3745 2.83344 28.7745 2.83344C28.1745 2.83344 27.6634 2.314 27.6634 1.6765C27.6634 1.039 28.1745 0.519547 28.7745 0.519547ZM27.8856 4.27371H29.6411V13.3168H27.8856V4.27371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5979 4.27382H33.3534V6.61132C33.8201 5.07659 34.9312 4.10854 36.3979 4.10854C38.3534 4.10854 39.6868 5.71409 39.6868 7.93354V13.3405H37.9312V8.21687C37.9312 6.82382 36.9756 5.80854 35.7312 5.80854C34.3312 5.80854 33.3534 6.82382 33.3534 8.21687V13.3405H31.5979V4.27382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4645 0.519547C43.0645 0.519547 43.5533 1.039 43.5533 1.6765C43.5533 2.314 43.0645 2.83344 42.4645 2.83344C41.8645 2.83344 41.3533 2.314 41.3533 1.6765C41.3533 1.039 41.8645 0.519547 42.4645 0.519547ZM41.5755 4.27371H43.3311V13.3168H41.5755V4.27371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64 13.7182V4.27371H47.3956V13.7182C47.3956 15.6543 46.64 17.1418 44.1066 17.0001V15.3473C45.3289 15.3709 45.64 14.9932 45.64 13.7182ZM46.5066 0.519547C47.1066 0.519547 47.5956 1.039 47.5956 1.6765C47.5956 2.314 47.1066 2.83344 46.5066 2.83344C45.9066 2.83344 45.4178 2.314 45.4178 1.6765C45.4178 1.039 45.9066 0.519547 46.5066 0.519547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4448 4.08371C56.1782 4.08371 58.1338 6.44482 57.8226 9.4198H50.7782C51.0226 10.8601 52.1115 11.8754 53.5782 11.8754C54.6893 11.8754 55.6004 11.2615 56.0893 10.2698L57.556 10.9545C56.8226 12.442 55.4004 13.481 53.5338 13.481C50.9782 13.481 49.0226 11.4504 49.0226 8.7823C49.0226 6.13788 50.9338 4.08371 53.4448 4.08371ZM56.0671 7.97954C55.7782 6.68093 54.8004 5.71288 53.4448 5.71288C52.156 5.71288 51.1338 6.65732 50.8226 7.97954H56.0671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.824 11.1449C61.424 11.1449 61.9129 11.6644 61.9129 12.3019C61.9129 12.9394 61.424 13.4824 60.824 13.4824C60.224 13.4824 59.7129 12.963 59.7129 12.3019C59.7129 11.6644 60.224 11.1449 60.824 11.1449ZM59.8462 0.921326H61.7796V9.65741H59.8462V0.921326Z",
    fill: "#FF660A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24238_10581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJeftinije);
export default __webpack_public_path__ + "static/media/logo-jeftinije.d0c8801f9c434bd4e9d8e3d4c48c046d.svg";
export { ForwardRef as ReactComponent };